'use strict'
const bondsPortfolio = () => {
  const formElement = document.getElementsByClassName('js-upload-xls')
  const input = document.getElementsByClassName('js-upload-xls-input')
  const span = document.querySelectorAll('.js-xls-file-title')[0]
  const foundBonds = document.querySelectorAll('.js-found-bonds')[0]
  const notFoundBonds = document.querySelectorAll('.js-not-found-bonds')[0]
  const loadXlsButton = document.getElementsByClassName('js-load-xls-table')
  const preloader = document.getElementsByClassName('js-preloader')[0]
  const modalContainer = document.getElementsByClassName('js-modal__container-xls')[0]

  formElement[0].addEventListener(
  'change',
  async (event) => {
      let file = input[0].files[0]
      if (file) {
        span.innerHTML = file.name
      }
  })

  formElement[0].addEventListener(
    'submit',
    async (event) => {
      event.preventDefault()
      const formData = new FormData(formElement[0])
      let file = input[0].files[0]

      if (file === undefined) {
        return false
      }

      if (file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        notFoundBonds.innerHTML = ''
        foundBonds.innerHTML = `<h5 class="clr-red">Неверный формат файла, загрузите файл в формате Excel</h5><br>`
        loadXlsButton[0].style.display = 'none'
        return false
      }

      if (file.size > 5242880) {
        notFoundBonds.innerHTML = ''
        foundBonds.innerHTML = `<h5 class="clr-red">Размер файла не должен превышать 5MB</h5><br>`
        loadXlsButton[0].style.display = 'none'
        return false
      }

      loadXlsButton[0].style.display = 'none'
      preloader.style.display = 'block'
      preloader.style.opacity = '1'
      modalContainer.style.minHeight = '260px'

      formData.append('file', file)
      const request = await fetch(
        '/assets/components/dohodbonds/connectorweb.php?action=portfolio',
        {
          method: 'POST',
          body: formData
        }
      )

      if (request.ok) {
        preloader.style.display = 'none'
        preloader.style.opacity = '0'
        modalContainer.style.minHeight = 'auto'
      }

      let result = await request.json()

      let foundBondsLength = result['result'].length
      let notFoundBondsLength = Object.keys(result['unknown']).length

      if (foundBondsLength !== 0) {
        foundBonds.innerHTML = `<h5 class='clr-green'><b>${foundBondsLength}</b> ISIN загружены успешно</h5><br>`
      } else {
        foundBonds.innerHTML = `<h5 class="clr-red">Совпадений не найдено!</h5><br>`
      }

      if (notFoundBondsLength !== 0) {
        notFoundBonds.innerHTML = `<h5 class="clr-red"><b>${notFoundBondsLength}</b> ISIN не найдены в нашей базе</h5><br>`
        notFoundBonds.innerHTML += '<ul>'
        for (let key in result['unknown']) {
          notFoundBonds.innerHTML += '<li>' + result['unknown'][key] + '</li>'
        }
        notFoundBonds.innerHTML += '</ul>'
      } else {
        notFoundBonds.innerHTML = ''
      }

      if (foundBondsLength !== 0) {
        loadXlsButton[0].style.display = 'flex'
      }
    },
    false
  );

}

export {bondsPortfolio}